import React from "react"
import '@westernunion/css/lang/wuds.ar.css'
const LanguageAR = () => {
    return (
        <></>
      )
}
export default LanguageAR
